/**
 * Semester milestone configuration for first lesson, mid-semester, and final markers.
 * Shared between timeline and lesson card components.
 */

export interface SemesterMilestoneConfig {
	icon: string;
	label: string;
}

export const SEMESTER_MILESTONE_CONFIG: Record<number, SemesterMilestoneConfig> = {
	2: {
		icon: 'untitled-ui/maps/rocket-02',
		label: 'Semester Start'
	},
	4: {
		icon: 'untitled-ui/shapes/star-01',
		label: 'Mid Semester'
	},
	5: {
		icon: 'untitled-ui/maps/flag-01',
		label: 'Final'
	}
};

/**
 * Get the icon for a semester milestone type.
 * Returns null if the type is not a recognized milestone.
 */
export function getSemesterMilestoneIcon(semesterLessonTypeID: number): string | null {
	return SEMESTER_MILESTONE_CONFIG[semesterLessonTypeID]?.icon ?? null;
}

/**
 * Get the label for a semester milestone type.
 * Returns null if the type is not a recognized milestone.
 */
export function getSemesterMilestoneLabel(semesterLessonTypeID: number): string | null {
	return SEMESTER_MILESTONE_CONFIG[semesterLessonTypeID]?.label ?? null;
}
